import React from "react";
import Spaces from "../../../../components/Spaces";

export default function(props: any) {
  
  return(<section className={"text--center"}>
    L'entreprise ne souhaite pas partager ses postes ouverts
    <Spaces n={3}/>
  </section>);
}